import { render, staticRenderFns } from "./ocrRecognitionAI.vue?vue&type=template&id=2a6dc602&scoped=true&"
import script from "./ocrRecognitionAI.vue?vue&type=script&lang=js&"
export * from "./ocrRecognitionAI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6dc602",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a6dc602')) {
      api.createRecord('2a6dc602', component.options)
    } else {
      api.reload('2a6dc602', component.options)
    }
    module.hot.accept("./ocrRecognitionAI.vue?vue&type=template&id=2a6dc602&scoped=true&", function () {
      api.rerender('2a6dc602', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ToolAssistant/ocrRecognitionAI.vue"
export default component.exports